import { computed, ref } from '@vue/composition-api'

export function useSteps(options: { initialStep: number, maxSteps: number }) {
    const current = ref(options?.initialStep || 1)
    const total = ref(options?.maxSteps || 1)
    const completed = ref(1)

    const hasNext = computed(() => current.value < total.value)
    const hasPrevious = computed(() => current.value > 1)
    const isFirst = computed(() => current.value === 1)
    const isLast = computed(() => current.value === total.value)

    function next() {
        if (hasNext.value) {
            current.value++
            completed.value++
        }
    }

    function previous() {
        if (hasPrevious.value) {
            current.value--
        }
    }

    function reset() {
        current.value = 1
        completed.value = 1
    }

    return {
        current,
        total,
        completed,
        hasNext,
        hasPrevious,
        isFirst,
        isLast,
        next,
        previous,
        reset,
    }
}
